export enum SystemConfiguration {
  GTM_ID = 'gtm_id',
  GTM_AUTH = 'gtm_auth',
  GTM_PREVIEW = 'gtm_preview',
  CREATE_INVOICE = 'create_invoice',
  SESSION_TIMEOUT = 'session_timeout',
  SYSTEM_EMAIL = 'system_email',
  UPLOAD_FILE_MAX_SIZE = 'upload_file_max_size',
  UPLOAD_FILE_EXTENSIONS = 'upload_file_extensions',
  VERIFICATION_TOKEN_VALIDITY_HOURS = 'verification_token_validity_hours',
  BUDGET_PLANNING_XLS = 'budget_planning_xls',
  BIOLOGICAL_FARMING_REPORT_XLS = 'biological_farming_report_xls',
}
